var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoonriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37241 12.1666C8.5377 12.1666 8.67169 12.3006 8.67169 12.4659L8.67169 15.9883C8.67169 16.1536 8.5377 16.2875 8.37241 16.2875C8.20713 16.2875 8.07313 16.1536 8.07313 15.9883L8.07313 12.4659C8.07313 12.3006 8.20713 12.1666 8.37241 12.1666Z",
    fill: "#4FCCC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91756 13.0025C7.08285 13.0025 7.21684 13.1365 7.21684 13.3018L7.21684 15.8031C7.21684 15.9684 7.08285 16.1024 6.91756 16.1024C6.75228 16.1024 6.61829 15.9684 6.61829 15.8031L6.61828 13.3018C6.61828 13.1365 6.75228 13.0025 6.91756 13.0025Z",
    fill: "#4FCCC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0755 12.4659C10.0755 12.3006 9.9415 12.1666 9.77621 12.1666C9.61093 12.1666 9.47693 12.3006 9.47693 12.4659V19.3458C9.47693 19.5111 9.61093 19.6451 9.77621 19.6451C9.9415 19.6451 10.0755 19.5111 10.0755 19.3458L10.0755 12.4659Z",
    fill: "#4FCCC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1545 12.7022C11.3198 12.7022 11.4538 12.8362 11.4538 13.0015V15.4527C11.4538 15.618 11.3198 15.752 11.1545 15.752C10.9892 15.752 10.8552 15.618 10.8552 15.4527V13.0015C10.8552 12.8362 10.9892 12.7022 11.1545 12.7022Z",
    fill: "#4FCCC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8831 13.7636C12.8831 13.5983 12.7491 13.4644 12.5838 13.4644C12.4185 13.4644 12.2845 13.5983 12.2845 13.7636V14.5524C12.2845 14.7177 12.4185 14.8517 12.5838 14.8517C12.7491 14.8517 12.8831 14.7177 12.8831 14.5524V13.7636Z",
    fill: "#4FCCC6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9876 14.0678C14.1529 14.0678 14.2869 14.2017 14.2869 14.367V17.9863C14.2869 18.1516 14.1529 18.2856 13.9876 18.2856C13.8223 18.2856 13.6883 18.1516 13.6883 17.9863V14.367C13.6883 14.2017 13.8223 14.0678 13.9876 14.0678Z",
    fill: "#4FCCC6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7162 14.5524C15.7162 14.3871 15.5822 14.2532 15.4169 14.2532C15.2517 14.2532 15.1177 14.3871 15.1177 14.5524V17.5332C15.1177 17.6984 15.2517 17.8324 15.4169 17.8324C15.5822 17.8324 15.7162 17.6984 15.7162 17.5332V14.5524Z",
    fill: "#4FCCC6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 13.8587C17.0371 13.8587 17.1711 13.9927 17.1711 14.158V15.6177C17.1711 15.783 17.0371 15.917 16.8718 15.917C16.7065 15.917 16.5725 15.783 16.5725 15.6177V14.158C16.5725 13.9927 16.7065 13.8587 16.8718 13.8587Z",
    fill: "#4FCCC6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7994 10.1544C17.7994 10.5236 17.7649 10.8847 17.699 11.2347C14.8745 12.7418 13.547 11.8723 12.2289 11.0089C10.8295 10.0923 9.44058 9.1825 6.28209 11.1297C6.22839 10.8126 6.20043 10.4868 6.20043 10.1544C6.20043 6.95137 8.79694 4.35486 11.9999 4.35486C15.2029 4.35486 17.7994 6.95137 17.7994 10.1544Z",
    fill: "#F2B705"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79133 11.3457C8.96305 11.2817 7.89269 11.5354 6.35925 12.4954C6.21916 12.5832 6.03448 12.5407 5.94677 12.4006C5.85907 12.2605 5.90154 12.0758 6.04163 11.9881C7.63608 10.9899 8.83506 10.6715 9.83747 10.749C11.5962 10.8849 12.719 12.475 14.4057 12.7697C15.1972 12.908 16.2063 12.7716 17.6559 11.9792C17.8009 11.8999 17.9828 11.9532 18.062 12.0982C18.1413 12.2433 18.088 12.4251 17.943 12.5044C16.4147 13.3398 15.2669 13.5278 14.3027 13.3593C11.8436 12.7022 11.5004 11.4779 9.79133 11.3457Z",
    fill: "#4FCCC6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonriver);
export default __webpack_public_path__ + "static/media/moonriver.d1be5ea7c82ca1d86ebe60bc008fe0c1.svg";
export { ForwardRef as ReactComponent };